export const Administrador = 'Administrador';
export const Facturacion = 'Facturación';
export const Directivo = 'Directivo';
export const Almacen = 'Almacén';
export const Vendedor_Interno = 'Vendedor Interno';
export const Vendedor_Externo = 'Vendedor Externo';
export const Cuentas_Claves = 'Cuentas Claves';

